import styled from 'styled-components/native';
import {Dimensions, StyleSheet} from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import theme from '../../../global/styles/theme';

export const Container = styled.SafeAreaView<{appTheme: 'light' | 'dark'}>`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  width: 100%;
  height: 100%;
`;

export const Image = styled.Image`
  height: 100px;
`;

export const Column = styled.View`
  align-items: center;
  width: 100%;
`;

export const Body = styled.View`
  align-items: center;
  margin-top: 20px;
  flex: 1;
  width: ${Dimensions.get('window').width};
  padding-bottom: 80px;
`;

export const Footer = styled.View`
  flex-direction: row;
  margin-top: 10px;
  width: 100%;
`;

export const ContainerArea = styled.View<{appTheme: 'light' | 'dark'}>`
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
`;

export const Box = styled.View<{appTheme: 'light' | 'dark'}>`
  border-radius: 10px;
  margin-bottom: 40px;
  border-width: 0.5px;
  border-color: ${({appTheme}) => theme.colors(appTheme).gray[800]};
  padding: 10px;
  width: ${Dimensions.get('window').width / 1.1};
`;

export const IconImage = styled(MaterialIcons)``;

export const ItemOptionHeader = styled.View`
  width: 90%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

export const ItemOption = styled.TouchableOpacity`
  width: 90%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
`;

export const Row = styled.View`
  flex-direction: row;
  gap: 10px;
`;

export const ButtonAction = styled.View`
  width: 90%;
  align-items: flex-end;
  justify-content: flex-end;
  margin-bottom: 100px;
`;

export const ContainerModal = styled.View<{appTheme: 'light' | 'dark'}>`
  width: 90%;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  border-radius: 10px;
  align-self: center;
  padding: 20px;
  min-height: 220px;
`;

export const styles = StyleSheet.create({
  shadowButton: {
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
    elevation: 5,
  },
});
